
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

const FooterFrame = () => {
  const footerItems = [
    {
      label: "Legal",
      content: "Our legal framework ensures compliance with all applicable laws and regulations. We maintain transparency in all business operations and adhere to industry standards. Contact support@ingant.com for full legal terms and conditions."
    },
    {
      label: "Terms of Service",
      content: "By using our services, you agree to our terms and conditions. These terms govern your use of our platform and define the relationship between you and our company. Contact support@ingant.com for complete terms and conditions."
    },
    {
      label: "Privacy Information",
      content: "We are committed to protecting your personal information and privacy. Our privacy policy outlines how we collect, use, and safeguard your data in accordance with applicable privacy laws. Contact support@ingant.com for full privacy terms and conditions."
    },
    {
      label: "Responsible Disclosure",
      content: "We encourage responsible disclosure of security vulnerabilities. If you discover any security issues, please report them through our designated channels so we can address them promptly. Contact support@ingant.com for full disclosure terms and conditions."
    },
    {
      label: "Trust",
      content: "Trust is fundamental to our business. We implement robust security measures, maintain data integrity, and ensure reliable service delivery to earn and maintain your confidence. Contact support@ingant.com for full trust and security terms and conditions."
    },
    {
      label: "Contact",
      content: "Get in touch with our support team for assistance, questions, or feedback. We're here to help you with any inquiries about our services. Reach us at support@ingant.com for direct support."
    },
    {
      label: "Cookie Preferences",
      content: "Manage your cookie preferences to control how we use cookies and similar technologies on our platform. You can customize your settings to align with your privacy preferences. Contact support@ingant.com for full cookie terms and conditions."
    },
    {
      label: "Your Privacy Choices",
      content: "Exercise control over your personal data and privacy settings. You have rights regarding how your information is collected, used, and shared. Contact support@ingant.com for full privacy choice terms and conditions."
    }
  ];

  return (
    <div className="w-full bg-gray-900 px-6 relative z-20 py-[11px]">
      <div className="container mx-auto">
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2">
          {footerItems.map(item => (
            <HoverCard key={item.label}>
              <HoverCardTrigger asChild>
                <a href="#" className="text-gray-400 hover:text-white text-xs underline">
                  {item.label}
                </a>
              </HoverCardTrigger>
              <HoverCardContent 
                className="bg-black text-white text-[9px] p-3 max-w-xs border border-gray-600"
                side="top"
                align="center"
              >
                {item.content}
              </HoverCardContent>
            </HoverCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterFrame;
